<template>
    <div class="filter-container">
        <div class="block">
            <div class="container">
                <h3>{{$t('common.categories')}}</h3>
                <div class="inputs">
                    <a
                        :key="item.term_id"
                        v-for="item in filters"
                        @click="handleClick(item)"
                        :class="['filter-cta', 'underline', {
                            active: item.term_id === (currentTerm.term_id)
                        }]"
                    >
                        <span class="caption">{{item.name}}</span>
                        <span class="count">{{item.count}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            default() {return []}
        },
        currentTerm: {
            type: Object,
            default() {return {}}
        }
    },
    data() {
        return {
            markets: [],
            techniques: [],
            countries: [],
            currentRegion: null
        }
    },
    methods: {
        handleClick(item) {
            this.$emit('updateFilter', item)
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.filter-container
    background-color: white
    border-bottom: 1px solid #e0e1e3
    border-top: 1px solid #e0e1e3
    margin-top: -30px
.block
    display: flex
    padding-top: 3%
    padding-bottom: 3%

.container
    flex: 1
h3
    font-size: 28px
    font-weight: 500
    color: #636772
    margin-bottom: 1.5em
.filter-cta
    font-size: 17px
    font-weight: 500
    color: #636772
    display: block
    cursor: pointer
    .underline
        line-height: 2.3529411765em

    &.active
        color: #ff2b2a
        .count
            opacity: 1
.inputs
    display: flex
    flex-direction: row
    flex-wrap: wrap
.filter-cta
    width: 145px
    display: flex
    justify-content: space-between
    margin-right: 86px
    margin-bottom: 1.2em
    padding-bottom: 8px
.caption
.count
    opacity: 0.3

</style>
